import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';

const functions = getFunctions(app, 'europe-west2');

/**
 * Creates a Stripe Checkout Session via Cloud Function and returns the hosted URL.
 * @param {'monthly'|'90day'} planType
 * @param {string} successUrl - URL Stripe redirects to on success
 * @param {string} cancelUrl  - URL Stripe redirects to on cancel
 * @returns {Promise<{ url: string }>}
 */
export async function createCheckoutSession(planType, successUrl, cancelUrl) {
  const fn = httpsCallable(functions, 'createCheckoutSession');
  const result = await fn({ planType, successUrl, cancelUrl });
  return result.data;
}

/**
 * Cancels the current user's monthly subscription at the end of the billing period.
 * The subscription stays active until the period ends; no immediate loss of access.
 */
export async function cancelSubscription() {
  const fn = httpsCallable(functions, 'cancelSubscription');
  const result = await fn({});
  return result.data;
}
